export default __webpack_public_path__ + "static/media/profile.e91eb6d3.png";